import { makeGtmCall } from '../utils.js'
import YouTubeIframeLoader from 'youtube-iframe'

export default class YoutubeVideo {
    constructor(self) {
        this.self = self
        const videoId = self.video.dataset.videoId
        const id = self.video.getAttribute('id')

        this.scrollTrigger = self.el.dataset.scrollTrigger
        this.scrolledTo = false

        YouTubeIframeLoader.load((YT) => {
            this.player = new YT.Player(id, {
                height: '495',
                width: '880',
                videoId: videoId,
                origin: window.location.origin,
                playerVars: {
                    rel: 0,
                },
                events: {
                    onReady: this.ytPlayerReady,
                },
            })
        })
    }

    ytPlayerReady = (e) => {
        this.self.controls.play.addEventListener('click', this.ytPlayVideo)
        this.self.controls.pause.addEventListener('click', this.ytPauseVideo)
        if (this.scrollTrigger) {
            e.target.mute()
            this.handleScrollTrigger()
            window.addEventListener('scroll', () => {
                this.handleScrollTrigger()
            })
        }
    }

    ytPlayVideo = () => {
        this.player.playVideo()
        this.self.el.classList.add(this.self.activeClass)
        makeGtmCall(this.self.el)
    }

    ytPauseVideo = () => {
        this.player.pauseVideo()
        this.self.el.classList.remove(this.self.activeClass)
    }

    handleScrollTrigger = () => {
        const offsetTop =
            this.self.el.getBoundingClientRect().top - window.innerHeight

        if (!this.scrolledTo && offsetTop < 0) {
            this.ytPlayVideo()
            this.scrolledTo = true
        }
    }
}
